import { match } from 'ts-pattern';
import useUrlStep from 'hooks/ui/useUrlStep';

export enum CreationStep {
  CreateUpdate = 'create',
  ReviewAndPublish = 'review',
  Complete = 'complete',
}

const useCreationStep = (dataIsValid?: boolean) => {
  const getValidStep = (rawStep: string | null) =>
    match(rawStep)
      .with(CreationStep.ReviewAndPublish, CreationStep.Complete, (step) =>
        dataIsValid ? step : CreationStep.CreateUpdate,
      )
      .otherwise(() => CreationStep.CreateUpdate);

  return useUrlStep(getValidStep);
};

export default useCreationStep;
